import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { transformStr3, getformListItemsdatas, setformdata, handleHttp, formateDate } from "@/utils/utils";
import Swiper from 'swiper';
export default {
  name: 'collection',
  meta: {
    title: '藏品公开库'
  },
  data() {
    return {
      logoimg: '',
      ydsearch: true,
      props: {
        children: 'children',
        label: 'title'
      },
      Keyword: '',
      typeData: [],
      List: [],
      totalPage: 0,
      total: 0,
      listImgFlag: true,
      hasImg: 'checked',
      hasImgflag: true,
      currentTypeArr: [],
      checkedkeys: [],
      params: {
        page: 1,
        limit: 10,
        showImageflag: true,
        antiqueTypes: '',
        antiqueName: ''
      },
      currentPage: 1,
      detail: '',
      ldflag: true,
      antiquetitle: '',
      ydmenu: false,
      singleform: {
        limit: 12,
        page: 1
      },
      // hasSearch: false,
      checkedTree: [],
      searchStr: '',
      eraData: [],
      checkedEra: [],
      contentHeight: '',
      showIndex: 0,
      themeColor: '',
      isLoading: true,
      themes: {
        '黄色': 'yellow',
        '红色': 'red',
        '蓝色': 'blue',
        '绿色': 'green'
      },
      // 改变列表页选择时候的样式
      activeColors: {
        '黄色': '#caa452',
        '红色': 'rgb(140,45,45)',
        '蓝色': 'rgb(88,130,154)',
        '绿色': 'rgb(134,153,123)'
      },
      bgColor: '',
      title: '藏品公开库',
      logoImg: '',
      totalNum: 0,
      totalInfo: {
        page: 1,
        totalPage: 1
      },
      lock: false,
      treeNodes: [],
      eraNodes: [],
      theme: {},
      bigImg: '',
      swiperIndex: 0,
      conList: [],
      //新的列表
      checkedLevel: [],
      //等级列表
      levelData: [],
      JXZYXY: 30015,
      //江西职业学院定制
      kuangchuangDetail: {},
      //矿床详情
      radioTypeData: '',
      //矿床的选择
      showKcDesc: false,
      //是否展示 展开/收起的样式
      showKc: false,
      //是否显示矿床
      showMagnifierFlag: true,
      showPouMian: false,
      allKCData: [],
      //江西矿床列表
      jxSearchTypes: [{
        title: '藏品名称',
        key: 'antiqueName'
      }, {
        title: '藏品编号',
        key: 'antiqueCode'
      }, {
        title: '所属展厅',
        key: 'exhibitionHall'
      }, {
        title: '所属矿床',
        key: 'kuangchuang'
      }, {
        title: '产地',
        key: 'classifyCode'
      }, {
        title: '捐赠人',
        key: 'donor'
      }],
      jxSearchType: 0,
      jxSearchCons: [],
      //江西需要展示的筛选类型
      jxSearchConSelect: '',
      //选中的筛选内容
      fid: this.$route.query.fid,
      PZXBWG: 220507 //彭泽县博物馆
    };
  },
  methods: {
    // 切换江西的筛选类型
    changeJxSearch() {
      this.Keyword = '';
      this.jxSearchConSelect = '';
      if (this.jxSearchType == 2 || this.jxSearchType == 3) {
        this.jxSearchCons = this.jxSearchType == 2 ? this.typeData : this.allKCData;
      } else {
        this.jxSearchCons = [];
      }
    },
    showMagnifier() {
      this.showMagnifierFlag = true;
    },
    hideMagnifier() {
      this.showMagnifierFlag = false;
    },
    moveMagnifier(e) {
      console.log(76578658);
      if (!this.showMagnifierFlag || !this.$refs.magnifier || !this.$refs.mainImage) return;
      const image = this.$refs.mainImage[this.swiperIndex];
      const mag = this.$refs.magnifier[this.swiperIndex];
      console.log(mag, 'mag', this.swiperIndex);
      // 计算鼠标在图片上的相对位置
      const rect = image.getBoundingClientRect();
      console.log(rect, 'rect');
      let x = e.pageX - rect.left - window.scrollX;
      let y = e.pageY - rect.top - window.scrollY;

      // 防止放大镜超出图片边界
      x = Math.max(mag.offsetWidth / 2, Math.min(x, image.offsetWidth - mag.offsetWidth / 2));
      y = Math.max(mag.offsetHeight / 2, Math.min(y, image.offsetHeight - mag.offsetHeight / 2));

      // 设置放大镜位置
      mag.style.left = x - mag.offsetWidth / 2 + 'px';
      mag.style.top = y - mag.offsetHeight / 2 + 'px';

      // 设置放大镜背景（放大效果）
      const bgPosX = -(x * image.naturalWidth / image.offsetWidth - mag.offsetWidth / 2);
      const bgPosY = -(y * image.naturalHeight / image.offsetHeight - mag.offsetHeight / 2);
      mag.style.backgroundImage = `url(${this.detail.bannerArr[this.swiperIndex]})`;
      mag.style.backgroundSize = `${image.naturalWidth}px ${image.naturalHeight}px`;
      mag.style.backgroundPosition = `${bgPosX}px ${bgPosY}px`;
    },
    // 放大图片
    swipertop(img) {
      // console.log(img)
      this.bigImg = img;
    },
    // 滚动事件
    scrollEvent(e) {
      if (e.srcElement.scrollTop + e.srcElement.clientHeight >= e.srcElement.scrollHeight - 150) {
        if (this.isLoading) return;
        if (this.totalPage == this.currentPage) return;
        this.currentPage = this.currentPage + 1;
        this.getDetailByCode();
      }
    },
    ydshowmenu() {
      this.ydmenu = true;
    },
    ydshowsearch() {
      this.ydsearch = true;
    },
    ydhidesearch() {
      this.ydsearch = false;
    },
    shadefun() {
      this.ydmenu = false;
    },
    /* 是否有图切换 */
    hasImghandle() {
      this.hasImgflag = !this.hasImgflag;
      // this.params.page = 1
      this.currentPage = 1;
      this.getList();
    },
    /* 搜索 */
    topSearch() {
      this.params.antiqueName = this.Keyword;
      this.checkedTree = [];
      this.$refs.tree.setCheckedKeys([]);
      this.ldflag = true;
      // this.params.page = 1
      this.currentPage = 1;
      this.conList = [];
      this.List = [];
      // this.hasSearch = this.Keyword ? true : false
      //江西的定制
      if (this.fid == this.JXZYXY) {
        this.searchStr = '';
        if (this.jxSearchCons.length && this.jxSearchConSelect || this.Keyword) {
          //下拉框且有值
          this.searchStr = {
            filters: [[{
              alias: this.jxSearchTypes[this.jxSearchType].key,
              compt: !this.jxSearchCons.length ? "editinput" : this.jxSearchType == 2 ? 'multipleselect' : 'selectbox',
              express: !this.jxSearchCons.length ? 'like' : 'match',
              range: null,
              val: !this.jxSearchCons.length ? this.Keyword : [this.jxSearchConSelect]
            }]],
            model: 0
          };
        }
      } else {
        this.searchStr = this.Keyword ? {
          filters: [[{
            alias: "antiqueName",
            compt: "editinput",
            express: 'like',
            id: 5,
            range: null,
            val: this.Keyword
          }]],
          model: 0
        } : '';
      }
      console.log(this.searchStr, 'searchStr');
      this.getDetailByCode();
      // this.defaultData()
    },
    toIndex() {
      this.checkedTree = [];
      this.$refs.tree.setCheckedKeys([]);
      this.currentPage = 1;
      this.searchStr = '';
      this.getDetailByCode();
    },
    getDetailByCode() {
      // console.log(this.showIndex)
      let formData = {
        deptId: this.$route.query.fid || '151066',
        formId: 90852,
        limit: document.body.clientWidth > 768 ? 15 : 10,
        page: this.currentPage,
        searchStr: '',
        t: '8e66675fbf2614a905216ff0a85ee946',
        onlyReturnCount: 0,
        uids: ""
      };
      if (this.$route.query.fid == 220507) {
        formData.orderBy = 'paixu', formData.orderType = 'asc';
      }
      if (this.$route.query.fid == 44699) {
        formData.orderBy = 'sort';
        formData.orderType = 'desc';
      }
      // 是否公开
      let a = {
        filters: [[{
          alias: "127",
          compt: "selectbox",
          express: "match",
          // id: 34,
          range: null,
          val: ['是']
        }]],
        model: 0
      };
      if (this.currentPage == 1) {
        this.totalInfo = {
          page: 1,
          totalPage: 0
        };
        this.totalNum = 0;
        if (this.lock) {
          setTimeout(() => {
            this.lock = false;
            this.getTotalNum();
          }, 800);
        } else {
          this.getTotalNum();
        }
      }
      let searchStr = JSON.parse(JSON.stringify(this.searchStr));
      console.log(searchStr, 'searchStr');
      // let searchStr = this.searchStr
      searchStr ? searchStr.filters.push(a.filters[0]) : '';
      formData.searchStr = searchStr ? encodeURI(JSON.stringify(searchStr)) : encodeURI(JSON.stringify(a));
      this.isLoading = true;
      if (!this.showIndex) {
        this.$api.singleadvanceSearch(formData).then(res => {
          this.totalPage = res.totalPage;
          this.total = res.totalRow;
          this.setData(res.dataList);
          this.isLoading = false;
        });
      } else {
        // console.log(formData)
        this.$api.singleadvanceSearchPost(formData).then(res => {
          // console.log(res)
          this.totalPage = res.totalPage;
          this.total = res.totalRow;
          // console.log(res.dataList)
          this.setData(res.dataList);
          this.isLoading = false;
        });
      }
    },
    // 获取总值
    getTotalNum() {
      if (this.$route.query.fid == this.JXZYXY) return;
      let formData = {
        deptId: this.$route.query.fid || '151066',
        formAlias: 90852,
        searchStr: '',
        statsFieldId: 69,
        statsType: 'sum'
      };
      // 是否公开
      let a = {
        filters: [[{
          alias: "127",
          compt: "selectbox",
          express: "match",
          // id: 34,
          range: null,
          val: ['是']
        }]],
        model: 0
      };
      let searchStr = JSON.parse(JSON.stringify(this.searchStr));
      searchStr ? searchStr.filters.push(a.filters[0]) : '';
      formData.searchStr = searchStr ? encodeURI(JSON.stringify(searchStr)) : encodeURI(JSON.stringify(a));
      this.$api.getStatistics(formData).then(res => {
        this.totalNum = res.resultMap.totalStcs69.value;
      });
    },
    removetype(val, type) {
      // 荆门定制
      if (type == 'level') {
        this.checkedLevel.splice(val, 1);
        let checkData = this.checkedLevel.map(c => {
          return c.title;
        });
        this.$refs.tree3.setCheckedKeys(checkData);
        return this.setCheckedParams();
      }
      let nodes, parents;
      if (this.$route.query.fid == this.JXZYXY) {
        //江西职业技术学院定制
        nodes = type ? '' : this.$refs.tree.getNode(this.checkedTree[val]);
        parents = nodes ? `${nodes.data.title}/` : '';
      } else {
        //标准版
        nodes = type ? this.$refs.tree2.getNode(this.checkedEra[val]) : this.$refs.tree.getNode(this.checkedTree[val]);
        parents = `${nodes.data.title}/`;
        type ? this.checkedEra.splice(val, 1) : this.checkedTree.splice(val, 1);
        let checkData = type ? this.checkedEra.map(c => {
          return c.title;
        }) : this.checkedTree.map(c => {
          return c.title;
        });
        type ? this.$refs.tree2.setCheckedKeys(checkData) : this.$refs.tree.setCheckedKeys(checkData);
        return this.setCheckedParams();
      }
      this.getParents(nodes, type ? 2 : 1, parents, false);
      // type == era 删除年代标签
      type ? this.checkedEra.splice(val, 1) : this.checkedTree.splice(val, 1);
      let checkData = type ? this.checkedEra.map(c => {
        return c.title;
      }) : this.checkedTree.map(c => {
        return c.title;
      });
      type ? '' : this.$refs.tree.setCheckedKeys(checkData);
      this.setCheckedParams();
      if (!type) return;
      this.radioTypeData = '';
      this.kuangchuangDetail = {};
    },
    removeAll() {
      this.checkedTree = [];
      this.checkedEra = [];
      this.checkedLevel = [];
      this.treeNodes = [];
      this.eraNodes = [];
      this.kuangchuangDetail = {};
      this.radioTypeData = '';
      this.$refs.tree.setCheckedKeys([]);
      this.$refs.tree2.setCheckedKeys([]);
      this.setCheckedParams();
    },
    /* 展示列表 */
    golist() {
      this.ldflag = true;
    },
    // 节点被展开 江西职业学院定制
    nodeExpand(data, node, obj) {
      console.log(data, node, obj);
      if (this.$route.query.fid != this.JXZYXY) return;
      data.title == '矿产资源厅' || data.title == '典型矿床' ? this.showKc = true : this.showKc = false;
    },
    /* 分类选择 */
    handleCheckChange(data, treedata) {
      let nodes = this.$refs.tree.getNode(data);
      this.checkedTree = treedata.checkedNodes.length ? treedata.checkedNodes : [];
      let parents = `${nodes.data.title}/`;
      // console.log('nodes')
      // console.log(nodes)
      // this.getParents(nodes, 1, parents, nodes.checked)
      this.getChildren(nodes, 1, parents, nodes.checked);
      this.setCheckedParams();
    },
    // 年代选择
    checkChangeEra(data, treedata) {
      this.checkedEra = treedata.checkedNodes.length ? treedata.checkedNodes : [];
      let nodes = this.$refs.tree2.getNode(data);
      // 新
      let parents = `${nodes.data.title}/`;
      // console.log('nodes')
      // console.log(nodes)
      // this.getParents(nodes, 1, parents, nodes.checked)
      this.getChildren(nodes, 2, parents, nodes.checked);
      this.setCheckedParams();
      // 原始
      // if (nodes.checked) {
      //   let parents = `${nodes.data.title}/`
      //   this.getParents(nodes, 2, parents, nodes.checked)
      //   // 年代可以全选，根据年代进行分类查询
      //   // this.getChildren(nodes, 2, parents, nodes.checked)
      // } else {
      //   let index = this.eraNodes.findIndex((item) => {return item.indexOf( nodes.data.title) > -1})
      //   index > -1 ? this.eraNodes.splice(index, 1) : ''
      // }
      // this.setCheckedParams()
    },
    //江西职业学院定制 矿床筛选
    checkChangeKuangChuang(data) {
      console.log(data, '23432');
      let nodesCheck = this.$refs.tree4.getNode(data).checked.toString();
      this.$nextTick(() => {
        // 如果已经选中了一个节点，则取消选择
        if (this.checkedEra.length && this.$refs.tree4) {
          this.$refs.tree4.setCheckedKeys([]);
          // 选中的话数据+1
          if (nodesCheck == 'true') this.$refs.tree4.setCheckedNodes([data]);
        }
        // 更新当前选中节点的 key
        this.checkedEra = this.checkedEra.length && nodesCheck != 'true' ? [] : [{
          title: data.title
        }];
        this.eraNodes = this.checkedEra.length && nodesCheck != 'true' ? [] : [data.title];
        this.kuangchuangDetail = this.checkedEra.length && nodesCheck != 'true' ? {} : this.allKCData.find(item => {
          return item.title == data.title;
        });
        this.setCheckedParams();
      });
    },
    // 荆门定制等级查询
    checkChangeLevel(data, treedata) {
      this.checkedLevel = treedata.checkedNodes.length ? treedata.checkedNodes : [];
      let nodes = this.$refs.tree3.getNode(data);
      // 定制文物等级查询
      this.setCheckedParams();
    },
    getParents(nodes, type, parents, checked) {
      if (!nodes) return;
      if (nodes.level != 0) {
        nodes.level != 1 ? parents += `${nodes.parent.data.title}/` : '';
        if (nodes.level == 1) {
          parents = parents.split('/').reverse().join('/').slice(1);
          if (!checked) {
            let index = type == 1 ? this.treeNodes.findIndex(item => {
              return item == parents;
            }) : this.eraNodes.findIndex(item => {
              return item == parents;
            });
            type == 1 ? this.treeNodes.splice(index, 1) : this.eraNodes.splice(index, 1);
          } else {
            type == 1 ? this.treeNodes.push(parents) : this.eraNodes.push(parents);
          }
          // console.log(this.treeNodes)
        }
        // console.log('this.eraNodes')
        // console.log(this.eraNodes)
        this.getParents(nodes.parent, type, parents, checked);
      }
    },
    getChildren(nodes, type, parents, checked) {
      parents = `${nodes.data.title}/`;
      this.getParents(nodes, type, parents, checked);
      if (nodes.childNodes.length) {
        nodes.childNodes.map(child => {
          this.getChildren(child, type, parents, checked);
        });
      }
    },
    setCheckedParams(type) {
      this.searchStr = this.checkedTree.length || this.checkedEra.length || this.checkedLevel.length ? {
        filters: [],
        model: 0
      } : '';
      this.lock = true;
      // console.log(this.checkedEra, this.checkedTree)
      if (this.checkedTree.length) {
        let filter = [{
          alias: this.$route.query.fid == this.JXZYXY ? 'exhibitionHall' : "antiqueType",
          compt: "multipleselect",
          express: 'match',
          range: null,
          val: this.treeNodes
        }];
        this.searchStr.filters.push(filter);
        // console.log(this.searchStr, 111)
      }
      if (this.checkedEra.length) {
        let filter = [{
          alias: this.$route.query.fid == this.JXZYXY ? 'kuangchuang' : "era",
          compt: this.$route.query.fid == this.JXZYXY ? 'selectbox' : "multipleselect",
          express: this.$route.query.fid == this.JXZYXY ? '===' : 'match',
          range: null,
          val: this.eraNodes
        }];
        this.searchStr.filters.push(filter);
      }
      if (this.checkedLevel.length) {
        let filter = [{
          alias: "antiqueLevel",
          compt: "selectbox",
          express: 'match',
          range: null,
          val: this.checkedLevel.map(item => {
            return item.title.replace('文物', '');
          })
        }];
        console.log(filter, 'filter');
        this.searchStr.filters.push(filter);
      }
      console.log(this.searchStr, 222);
      this.defaultData();
    },
    /* 默认参数 */
    defaultData(a) {
      this.currentPage = 1;
      this.List = [];
      this.conList = [];
      this.getDetailByCode();
    },
    /* 分页获取数据 */
    handleCurrentChange(val) {
      this.currentPage = val;
      // this.singleform.page = val
      this.getDetailByCode();
    },
    getList() {
      this.singleform.fid = this.$route.query.fid || '151066';
      this.singleform.formId = this.$route.query.formId;
      this.$api.singleformList(this.singleform).then(res => {
        this.total = res.total;
        this.setData(res.data);
      });
    },
    getStruct() {
      let params = {
        deptId: this.$route.query.fid || '151066',
        formId: 90852
      };
      this.$api.formStruct(params).then(res => {
        let target = res.find(d => {
          return d.alias == 'antiqueType';
        });
        if (this.$route.query.fid == this.JXZYXY) {
          //江西定制
          let typeData = res.find(d => {
            return d.alias == 'exhibitionHall';
          });
          typeData = typeData ? typeData.field.multiOptions : [];
          this.typeData = typeData;
          console.log(this.typeData, 'typeData');
          // 江西定制
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(['宝玉石厅']);
            this.searchStr = {
              filters: [],
              model: 0
            };
            let filter = [{
              alias: "exhibitionHall",
              compt: "multipleselect",
              express: 'match',
              range: null,
              val: ['宝玉石厅']
            }];
            this.searchStr.filters.push(filter);
            this.checkedTree = [{
              title: '宝玉石厅'
            }];
            this.getDetailByCode();
          });
        } else {
          //标准版
          target = target ? target.field.multiOptions : [];
          let eraData = res.find(d => {
            return d.alias == 'era';
          });
          eraData = eraData ? eraData.field.multiOptions : [];
          this.eraData = eraData;
          this.typeData = target;
        }
        if (this.$route.query.fid == '212368') {
          // 荆门博物馆定制增加一个等级
          let levelData = res.find(d => {
            return d.alias == 'antiqueLevel';
          });
          levelData = levelData ? levelData.field.options : [];
          this.levelData = levelData.map(item => {
            item.title = `${item.title}文物`;
            return item;
          });
        }
      });
      if (this.$route.query.fid != this.JXZYXY) return;
      // 江西职业学院的定制获取矿床列表
      let params2 = {
        deptId: this.$route.query.fid || '151066',
        formId: 2441472,
        t: 'a371d97e94f2ab7bf516c2910149223462ff15ea5556de6e783e8340f3f51f17',
        orderBy: 'manualOrderTop,manualOrder',
        orderType: 'desc',
        limit: 100
      };
      this.$api.singleadvanceSearchv2(params2).then(res => {
        if (res.totalRow > 0) {
          this.allKCData = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            return item.itemformdata;
          });
          this.eraData = this.allKCData.filter(e => {
            return !e.pKuangchuang;
          });
          this.eraData.map(t => {
            t.children = this.allKCData.filter(e => {
              return e.pKuangchuang && e.pKuangchuang == t.title;
            });
            return t;
          });
          console.log(this.allKCData, 'allKCData', this.typeData);
          return;
        }
        this.eraData = [];
      });
    },
    setData(data) {
      let list = data.map(item => {
        let target = {
          primaryImage: this.getFormData(item, 'primaryImage', 'fileUrl'),
          antiqueName: this.getFormData(item, 'antiqueName', 'val'),
          antiqueCode: this.getFormData(item, 'antiqueCode', 'val'),
          era: this.getFormData(item, 'era', 'val'),
          antiqueTypename: this.getFormData(item, 'antiqueType', 'val'),
          texturea: this.getFormData(item, 'texture', 'val'),
          detailSize: this.getFormData(item, 'detailSize', 'val'),
          incompleteLevel: this.getFormData(item, 'incompleteLevel', 'val'),
          remark: this.getFormData(item, 'remark', 'val'),
          aidedImage: this.getFormData(item, 'aidedImage', 'imgs'),
          otherImage: this.getFormData(item, 'otherImage', 'imgs'),
          exhibitionHall: this.getFormData(item, 'exhibitionHall', 'val'),
          kuangchuang: this.getFormData(item, 'kuangchuang', 'val'),
          classifyCode: this.getFormData(item, 'classifyCode', 'val'),
          originName: this.getFormData(item, 'originName', 'val'),
          generalLength: this.getFormData(item, 'generalLength', 'val'),
          generalHeight: this.getFormData(item, 'generalHeight', 'val'),
          incompleteState: this.getFormData(item, 'incompleteState', 'val'),
          generalWidth: this.getFormData(item, 'generalWidth', 'val'),
          donor: this.getFormData(item, 'donor', 'val'),
          donorTime: this.getFormData(item, 'donorTime', 'val'),
          remark2: this.getFormData(item, 'remark2', 'val')
        };
        return target;
      });
      this.currentPage == 1 ? this.List = list : this.List = this.List.concat(list);
      let conIndex = 0;
      let moreIndex = !this.ydsearch ? 1 : 4;
      if (this.currentPage == 1) {
        this.conList = !this.ydsearch ? [[], []] : [[], [], [], [], []];
        list.map((l, li) => {
          this.conList[conIndex].push(l);
          conIndex == moreIndex ? conIndex = 0 : conIndex++;
        });
      } else {
        list.map((l, li) => {
          this.conList[conIndex].push(l);
          conIndex == moreIndex ? conIndex = 0 : conIndex++;
        });
      }
      console.log(this.List);
    },
    getFormData(data, Tkey, key) {
      data = data.formIdValueData;
      if (!data[Tkey] || !data[Tkey].groupValues) return key == 'imgs' ? [] : '';
      let target = data[Tkey].groupValues[0];
      if (!target) return key == 'imgs' ? [] : '';
      if (key == 'imgs') {
        let values = target.values[0];
        return values.map(t => {
          return t ? `${process.env.VUE_APP_IMG_DOMAIN}/star3/origin/${t.objectId}.${t.suffix}` : '';
        });
      }
      if (key == 'fileUrl') {
        let values = target.values[0];
        if (!values[0]) return '';
        return `${process.env.VUE_APP_IMG_DOMAIN}/star3/origin/${values[0].objectId}.${values[0].suffix}`;
      }
      return target.values.length && target.values[0] ? target.values[0][0] ? target.values[0][0][key] : '' : '';
    },
    /* 切换列表图片展示方式 */
    changeType(val) {
      this.listImgFlag = val;
    },
    /* 根据当前节点 获取父节点 */
    findAncestry(arr, dictCode) {
      let temp = [];
      const List = arr;
      function forFn(list, id) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item.dictCode == id) {
            temp.push(item);
            if (item.parentCode !== 0) {
              forFn(List, item.parentCode);
            }
            break;
          } else {
            if (item.children !== undefined) {
              forFn(item.children, id);
            }
          }
        }
      }
      forFn(arr, dictCode);
      return temp;
    },
    /* 获取详情 */
    godetail(val) {
      console.log(val, 1111);
      this.detail = val;
      if (this.$route.query.fid == this.JXZYXY) {
        //江西藏品定制备注字段
        if (!this.detail.remark2) {
          this.detail.remark = '<p>' + this.detail.remark;
          this.detail.remark = this.detail.remark.replace('。', '。</p><p>');
          this.detail.remark = this.detail.remark + '</p>';
        } else {
          this.detail.remark = this.detail.remark2;
        }
      }
      if (this.detail.originName) {
        this.detail.originName = this.detail.originName.replace(/(\d+)/g, '<sub>$1</sub>');
      }
      let banner = [];
      this.detail.primaryImage ? banner = [this.detail.primaryImage] : '';
      this.detail.bannerArr = banner.concat(this.detail.aidedImage).concat(this.detail.otherImage);
      console.log(this.detail.bannerArr);
      let that = this;
      this.ldflag = false;
      this.$nextTick(() => {
        if (document.body.clientWidth > 768) {
          var galleryThumbs = new Swiper('.smallbox .gallery-thumbs', {
            spaceBetween: 20,
            slidesPerView: 3,
            navigation: {
              nextEl: '.smallbox .swiper-button-next',
              prevEl: '.smallbox .swiper-button-prev'
            },
            direction: 'vertical',
            autoplay: {
              delay: 5000,
              disableOnInteraction: true
            },
            observer: true,
            observerParents: true
          });
        }
        var galleryTop = new Swiper('.gallery-top', {
          spaceBetween: 20,
          thumbs: {
            swiper: galleryThumbs
          },
          pagination: {
            el: '.gallery-top .swiper-pagination',
            clickable: true
          },
          autoplay: this.$route.query.fid == this.JXZYXY ? false : {
            delay: 5000,
            disableOnInteraction: true
          },
          observer: true,
          observerParents: true,
          on: {
            slideChangeTransitionEnd: function (e) {
              that.swiperIndex = galleryTop.activeIndex;
            }
          }
        });
      });
    },
    getThemeColor() {
      let formData = {
        deptId: this.$route.query.fid || '151066',
        formId: 329432,
        limit: 10,
        page: 1,
        searchStr: ''
      };
      this.$api.singleadvanceSearch(formData).then(res => {
        if (!res.dataList || !res.dataList.length) {
          this.themeColor = 'yellow';
          this.title = '藏品公开库';
          this.bgColor = '#caa452';
          this.theme = {
            styleType: 1,
            needYear: 1
          };
          return;
        }
        let color = this.getFormData(res.dataList[0], 'color', 'val') || '黄色';
        this.title = this.getFormData(res.dataList[0], 'logoName', 'val') || '藏品公开库';
        this.logoImg = this.getFormData(res.dataList[0], 'logoImg', 'fileUrl') || '';
        let styleType = this.getFormData(res.dataList[0], 'styleType', 'val');
        let needYear = this.getFormData(res.dataList[0], 'needYear', 'val');
        this.theme = {
          styleType: styleType ? styleType.indexOf('统一') > -1 ? 2 : 1 : 1,
          needYear: needYear ? needYear == '是' ? 1 : 0 : 1
        };
        this.themeColor = this.themes[color];
        this.bgColor = this.activeColors[color];
      }).catch(msg => {
        this.themeColor = 'yellow';
        this.title = '藏品公开库';
      });
    },
    /*
    ** 下载Image
    */
    downloadImg() {
      let currentImg = this.detail.bannerArr[this.swiperIndex];
      console.log(currentImg);
      this.downloadImageHandle(currentImg, new Date().getTime());
    },
    downloadImageHandle(imgsrc, name) {
      var image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL('image/png');
        var a = document.createElement('a');
        var event = new MouseEvent('click');
        a.download = name || 'photo';
        a.href = url;
        a.dispatchEvent(event);
      };
      image.src = imgsrc;
    }
  },
  watch: {
    kuangchuangDetail: {
      handler(n, o) {
        this.$nextTick(() => {
          if (this.$refs.kuangchuangDesc.offsetHeight < 50) return this.showKcDesc = -1;
          this.showKcDesc = this.$refs.kuangchuangDesc.offsetHeight > 50 ? false : true;
        });
      },
      deep: true
    }
  },
  created() {
    this.getStruct();
    if (this.$route.query.fid != this.JXZYXY) {
      this.getDetailByCode();
    }
    this.getThemeColor();
    console.log(document.body.clientWidth);
    if (this.$route.query.fid == 334277) {
      // alert(document.body.clientWidth)
    }
    if (document.body.clientWidth < 1081) {
      this.ydsearch = false;
    }
  },
  computed: {}
};